// extracted by mini-css-extract-plugin
export default {"content":"InformationSection_content__GDgs-"};